import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import CartSidebar from "@/components/CartSidebar";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Prints from "@/pages/Prints";
import Services from "@/pages/Services";
import Wholesale from "@/pages/Wholesale";
import Faq from "@/pages/Faq";
import Quote from "@/pages/Quote";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import WholesaleAccount from "@/pages/WholesaleAccount";
import GiftCards from "@/pages/GiftCards";
import Admin from "@/pages/Admin";
import OrderConfirmation from "@/pages/OrderConfirmation";
import ScrollToTop from "@/components/ScrollToTop";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="bottom-right" />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/prints" element={<Prints />} />
              <Route path="/prints/:slug" element={<ProductDetail />} />
              <Route path="/services" element={<Services />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/account" element={<WholesaleAccount />} />
              <Route path="/gift-cards" element={<GiftCards />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
            </Routes>
          </Layout>
          <CartSidebar />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
